import { Command } from '@/app/common/base/command'

export class UploadDocumentCommand extends Command {
    public async run(data: FormData) {
        await this.client.multiPart('/api/documents', data)
    }
}
